<template>
    <div class="flex justify-center items-center">
        
        <div class="p-holder admin-pagination" v-if="totalPage > 0">
            <button class="p-btn p-prev" type="button" @click="previousPage()" aria-label="Previous page">
                <svg width="16" height="16" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/></svg>
            </button>
            <button type="button" class="p-btn" v-if="farFromStart" @click="toPage(1)" aria-label="1" :class="{active: value==1}">1</button>
            <div class="p-dot" v-if="farFromStart">...</div>
            <button type="button" class="p-btn" v-for="n in range()" :key="n" @click="toPage(n)" :aria-label="n" :class="{active: value==n}">{{n}}</button>
            <div class="p-dot" v-if="farFromEnd">...</div>
            <button type="button" class="p-btn" v-if="farFromEnd" @click="toPage(totalPage)" :aria-label="totalPage" :class="{active: value==totalPage}">{{totalPage}}</button>
            <button class="p-btn p-next" type="button" @click="nextPage()" aria-label="Next page">
                <svg width="16" height="16" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: ['totalPage', 'value', 'currentPageItems', 'sorting', 'totalItems'],
    model: {
        prop: 'value',
        event: 'change'
    },
    data() {
        return {
            farFromStart: false,
            farFromEnd: false,
            min: 1,
            max: 1
        }
    },
    computed: {
        showingItems() {
            if (!this.currentPageItems) {
                return ''
            }
            if (typeof this.currentPageItems.from == 'number' && typeof this.currentPageItems.to == 'number') {
                return this.$t('showing_items', {
                    from_to: `${this.currentPageItems.from} - ${this.currentPageItems.to}`,
                    total: this.totalItems
                })
            }
            return ''
        },
        sortingInfo() {
            return this.$t('sorting_by', {
                key: this.sorting.order_by,
                sort_order: this.$t(this.sorting.order_sort)
            })
        }
    },
    methods: {
        range() {
            var array = [],
            j = 0;
            for (var i = this.min; i <= this.max; i++) {
              array[j] = i;
              j++;
            }
            return array;
        },
        nextPage() {
            if (this.value + 1 <= this.totalPage)
                this.$emit('change', this.value + 1)
        },
        previousPage() {
            if (this.value - 1 > 0)
                this.$emit('change', this.value - 1)
        },
        toPage(p) {
            if (p != this.value)
                this.$emit('change', p)
        },
        render() {
            if (window.innerWidth < 768) {
                if (this.totalPage < 8) {
                    this.min = 1
                    this.max = this.totalPage
                    this.farFromStart = false
                    this.farFromEnd = false
                    return
                }

                if (this.totalPage - (this.value - 2) < 6) {
                    this.min = this.totalPage - 4
                    this.max = this.totalPage
                    this.farFromStart = true
                    this.farFromEnd = false
                    return
                }

                if (this.value < 4) {
                    this.min = 1
                    this.max = 3
                    this.farFromStart = false
                    this.farFromEnd = true
                    return
                }
                let min = this.value - 1
                let max = this.value + 1

                this.min = min
                this.max = max
                this.farFromStart = this.value > 5 ? true : false;
                this.farFromEnd = this.totalPage - this.value > 4 ? true : false
            } else {
                if (this.totalPage < 8) {
                    this.min = 1
                    this.max = this.totalPage
                    this.farFromStart = false
                    this.farFromEnd = false
                    return
                }

                if (this.totalPage - (this.value - 2) < 6) {
                    this.min = this.totalPage - 4
                    this.max = this.totalPage
                    this.farFromStart = true
                    this.farFromEnd = false
                    return
                }

                if (this.value < 4) {
                    this.min = 1
                    this.max = 5
                    this.farFromStart = false
                    this.farFromEnd = true
                    return
                }
                let min = this.value - 2
                if (min <=3) {
                    min = 1
                }
                let max = this.value + 2
                if (this.totalPage - max < 3) {
                    max = this.totalPage
                }

                this.min = min
                this.max = max
                this.farFromStart = this.value > 5 ? true : false;
                this.farFromEnd = this.totalPage - this.value > 4 ? true : false
            }
            
        },
        clearSorting() {
            this.$emit('clearsort')
        }

    },
    mounted() {
        this.render();
    },
    watch: {
        value() {
            this.render()
        },
        totalPage() {
            this.render()
        }
    }
}
</script>

<style scoped>
.p-holder {
    margin: 0.8em 0;
    justify-content: flex-end;
    display: flex;
}

.p-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    margin-right: 5px;
}
.p-btn:last-child {
    margin-right: 0px;
}

.p-next {
    border-radius: 6px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.p-prev {
    border-radius: 6px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.p-prev>svg,
.p-next>svg {
    margin-bottom: 3px;
}

.p-dot {
    width: 15px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: transparent;
    font-weight: 400;
    font-size: 12px;
    margin-right: 5px;
}
</style>
